import React from 'react';
import { Tooltip } from '@mui/material';
import moment from 'moment';
import { MAP_SWITCHERS_PANEL_WIDTH } from 'consts/mapControls';
import { SwitherComponent } from './Swither';

const buildImsmaSyncTooltipTitle = (imsmaLastSyncedAt) => {
  if (imsmaLastSyncedAt === undefined) {
    return <div>Loading sync date...</div>;
  }
  if (imsmaLastSyncedAt && moment(imsmaLastSyncedAt).isValid()) {
    const formatted = moment(imsmaLastSyncedAt).format('DD.MM.YYYY HH:mm');
    return <div>Last IMSMA sync: {formatted}</div>;
  }
  return <div>Last IMSMA sync date is not yet available.</div>;
};

export const HASwitchers = ({
  haReportsEnabled,
  setHaReportsEnabled,
  imsmaSwitchEnabled = false,
  setImsmaSwitchEnabled = () => {},
  // azureLayerEnabled,
  // setAzureLayerEnabled,
  haReportsLoader,
  imsmaLastSyncedAt,
  style = {},
  googleWms = false,
}) => {
  const defaultStyle = {
    position: 'absolute',
    left: '0px',
    top: googleWms ? '10px' : '66px',
    zIndex: 1,
    background: 'rgba(255, 255, 255, 0.8)',
    borderRadius: '4px',
    padding: '0px 15px 7px 10px',
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    ...style,
    width: MAP_SWITCHERS_PANEL_WIDTH,
    boxSizing: 'border-box',
  };

  return (
    <div style={defaultStyle} className="mapbox-control">
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <SwitherComponent
          checked={haReportsEnabled}
          handleSwitcher={() => setHaReportsEnabled(!haReportsEnabled)}
          labelRight="HA Reports"
          disabled={haReportsLoader}
        />

        {haReportsLoader && (
          <div
            style={{
              width: '16px',
              height: '16px',
              border: '2px solid #f3f3f3',
              borderTop: '2px solid #3498db',
              borderRadius: '50%',
              animation: 'spin 1s linear infinite',
            }}
          />
        )}
      </div>

      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <div className="swither-wrapper">
          <input
            type="checkbox"
            className="flipswitch"
            checked={imsmaSwitchEnabled}
            onChange={() => setImsmaSwitchEnabled(!imsmaSwitchEnabled)}
          />
          <Tooltip
            title={buildImsmaSyncTooltipTitle(imsmaLastSyncedAt)}
            placement="top"
            enterDelay={200}
            leaveDelay={0}
            componentsProps={{
              tooltip: {
                sx: {
                  fontSize: '0.9375rem',
                  lineHeight: 1.45,
                  py: 1,
                  px: 1.25,
                },
              },
            }}
          >
            <span style={{ whiteSpace: 'nowrap', cursor: 'default' }}>IMSMA HA Reports</span>
          </Tooltip>
        </div>
      </div>

      {/* <SwitherComponent
        checked={azureLayerEnabled}
        handleSwitcher={() => setAzureLayerEnabled(!azureLayerEnabled)}
        labelRight="Azure Maps"
      /> */}
    </div>
  );
};
